import { render } from "./LinkButton.vue?vue&type=template&id=791d7f3c&scoped=true"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"

import "./LinkButton.vue?vue&type=style&index=0&id=791d7f3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-791d7f3c"

export default script